import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { VectorElectricityChangesPage, VectorElectricityChangesPageProps } from "./VectorElectricityChangesPage";

export const EMPTY_PAGE_CONTENT: VectorElectricityChangesPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/electricity/connection-changes/vector-equipment";

export const VectorElectricityChangesPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<VectorElectricityChangesPageProps>(
    "electricity_changes___permanent_changes_to_vector_",
    EMPTY_PAGE_CONTENT,
  );
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <VectorElectricityChangesPage {...routeProps} {...content} />;
};
